import { Route, Routes } from "react-router-dom";
import Navbar from "../pages/public/Navbar";
import Landing from "../pages/public/Landing";
import { useState } from "react";
import Evento from "../pages/public/Evento";
import Shop from "../pages/public/Shop";
import LoginScreen from "../pages/public/LoginScreen";

export default function CoffeeDashboard() {
  const [isCartOpen, setIsCartOpen] = useState(false);
  return (
    <div className="w-full ">
      <Navbar setIsCartOpen={setIsCartOpen} isCartOpen={isCartOpen} />
      <main>
        <Routes>
          <Route path="/home" element={<Landing />} />
          <Route path="/evento" element={<Evento />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/login" element={<LoginScreen />} />
        </Routes>
      </main>
    </div>
  );
}
